export default {
  label: {
    notClassifiedLabel: 'No clasificado',
    notClassifiedLabelPlural: 'No clasificados',
    notShowClassifiedLabel: 'Mostrar no clasificados',
    showClassifiedLabel: 'Esconder no clasificados',
  },
};
